import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { v_DispatchEquipmentSvcdBus } from '../../../shared/models/v_DispatchEquipmentSvcdBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { EquipFieldData } from '@app/cp/shared/models/EquipFieldData';
import { EquipCustomFieldsComponent } from '../equip-custom-fields/equip-custom-fields.component';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { EquipmentService } from '@app/cp/shared/services/equipment.service';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { DispatchEquipPartsComponent } from '../parts/dispatch-equip-parts.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'dispatch-equip-svcd',
    templateUrl: './dispatch-equip-svcd.component.html',
    styleUrls: ['./dispatch-equip-svcd.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchEquipSvcdComponent extends BaseGridEditLineComponent<v_DispatchEquipmentSvcdBus, null, DispatchesService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, private svc_equip: EquipmentService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "v_DispatchEquipmentSvcdBus";
        this.appCode = "DispatchServicedEquipment";
        this.appName = "Dispatch Serviced Equipment";
    }
    @ViewChild('equipCustomFields') protected equipCustomFields: EquipCustomFieldsComponent;
    @ViewChild('equipParts') protected equipParts: DispatchEquipPartsComponent;
//    equipCustomData: EquipFieldData;
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchEquipmentXrefId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'equipmentId': new UntypedFormControl(),
            'systemId': new UntypedFormControl(),
            'isOnDispatchQuote': new UntypedFormControl(),
            'manufacturerId': new UntypedFormControl(),
            'model': new UntypedFormControl(),
            'serialNumber': new UntypedFormControl(),
            'manufacturerTypeId': new UntypedFormControl(),
            'barcode': new UntypedFormControl(),
            'notes': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'creationDate': new UntypedFormControl(),
            'manufacturerName': new UntypedFormControl(),
            'manufacturerTypeName': new UntypedFormControl(),
            'equipFieldData': new UntypedFormControl(),
            'locationId': new UntypedFormControl(),
            'hasExtraData': new UntypedFormControl(),
        });
    }
    setForm() {
        this.editForm.patchValue({
            dispatchEquipmentXrefId: this.selectedData.dispatchEquipmentXrefId,
            dispatchId: this.selectedData.dispatchId,
            equipmentId: this.selectedData.equipmentId,
            systemId: this.selectedData.systemId,
            isOnDispatchQuote: this.selectedData.isOnDispatchQuote,
            manufacturerId: this.selectedData.manufacturerId,
            model: this.selectedData.model,
            serialNumber: this.selectedData.serialNumber,
            manufacturerTypeId: this.selectedData.manufacturerTypeId,
            barcode: this.selectedData.barcode,
            notes: this.selectedData.notes,
            insertUserId: this.selectedData.insertUserId,
            insertDt: this.selectedData.insertDt,
            updateUserId: this.selectedData.updateUserId,
            updateDt: this.selectedData.updateDt,
            creationDate: this.selectedData.creationDate,
            manufacturerName: this.selectedData.manufacturerName,
            manufacturerTypeName: this.selectedData.manufacturerTypeName,
            equipFieldData: this.selectedData.equipFieldData,
            locationId: this.selectedData.locationId,
            hasExtraData: this.selectedData.hasExtraData
        });
    }
    all: boolean = false;
    allOrSvcdChanged(e: any) {
        console.log("allOrSvcdChanged: ", e, this.all);
        let param: CommonParam = new CommonParam();
        param.addParam("ACTION", "GETPAGEDATA");
        param.addParam("CODE", this.all ? "ALLEQUIP" : "SVCDEQUIP");
        param.addParam("ID", this.parentId);
        this.doAction.emit(param);
    }
    protected getChangedObject(dataObj: v_DispatchEquipmentSvcdBus) {
        let busObj: v_DispatchEquipmentSvcdBus = new v_DispatchEquipmentSvcdBus(dataObj);
        busObj.setBeforeSave();
        return busObj;
    }
    setFromReferenceData(data: v_DispatchEquipmentSvcdBus) {
        data.manufacturerName = this.referenceData.getManufacturerDesc(data.manufacturerId);
        data.manufacturerTypeName = this.referenceData.getManufacturerTypeDesc(data.manufacturerTypeId);
        return data;
    }

    protected save(data: v_DispatchEquipmentSvcdBus) {
        //busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        //busObj.setParentId(this._parentId);

        let busObj: v_DispatchEquipmentSvcdBus = this.getChangedObject(data);

        //return;
        this.svc_data.saveDispatchEquipment(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let dataObj: v_DispatchEquipmentSvcdBus = new v_DispatchEquipmentSvcdBus(info.primaryReturn);
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(info.primaryReturn, info.message);
            }
        });
    }
    deleteIndividual(data: v_DispatchEquipmentSvcdBus) {
        if (data.hasId) {
            this.svc_data.deleteDispatchEquipment(data.dispatchEquipmentXrefId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    cancelCustomFields() {
        this.ctrlOpenFlag = false;
    }
    saveCustomFields(data: EquipFieldData) {
        this.editForm.patchValue({
            equipFieldData: data,
        });
        this.editForm.markAsDirty();
        this.ctrlOpenFlag = false;
    }

    showCustomFields(equipmentId) {
        setTimeout(() => {
            this.ctrlOpenFlag = true;
            let dataObj: EquipFieldData = null;
            if (!this.editForm.value.equipFieldData || (!this.editForm.value.equipFieldData.hasId && this.selectedData.hasId)) {
                this.svc_equip.getEquipFieldData(equipmentId).subscribe(data => {
                    dataObj = new EquipFieldData(data);
                    this.equipCustomFields.show(dataObj, false);
                });
            } else {
                if (this.editForm.value.equipFieldData) {
                    dataObj = new EquipFieldData(this.editForm.value.equipFieldData);
                    this.equipCustomFields.show(dataObj, false);
                }
            }
        }, 500);
    }

    showParts(id:string) {
        this.ctrlOpenFlag = true;
            this.svc_equip.getEquipmentParts(id).subscribe(data => {
                this.equipParts.show(data.primaryReturn);
            });
    }
    protected removeLocal(data: v_DispatchEquipmentSvcdBus) {
        this.gridData = _.remove(this.gridData, function (n: v_DispatchEquipmentSvcdBus) {
            return n.equipmentId !== data.equipmentId;
        });
        this.cloneData();
    }
    test() {
        console.log("svcdeq->test", this.grid, this.gridData, this);
    }
}
